import { createSelector } from '@ngrx/store';
import { IUserState, userFeature } from './user.reducer';

export const { selectUserState, selectIs_onboarding_completed: selectIsOnboardingCompleted } = userFeature;

export const selectUser = createSelector(selectUserState, (user: IUserState) => ({
  first_name: user.first_name,
  is_email_verified: user.is_email_verified,
  is_onboarding_completed: user.is_onboarding_completed,
  position: user.position,
  tariff_ends_at: user.tariff_ends_at,
  tariff_name: user.tariff_name,
  max_projects: user.max_projects,
  projects_count: user.projects_count,
}));

export const selectUserVerify = createSelector(selectUserState, (user: IUserState) => user.is_email_verified);

export const selectUserName = createSelector(selectUserState, (user: IUserState) => user.first_name);

export const selectCanCreateProject = createSelector(
  selectUserState,
  (user: IUserState) => user.max_projects > user.projects_count,
);

export const selectUserAuth = createSelector(selectUserName, (name: string) => !!name);

export const selectProfile = createSelector(selectUserState, (user: IUserState) => ({
  first_name: user.first_name,
  position: user.position,
  sphere: user.sphere,
}));

export const selectIsBaseTariff = createSelector(selectUserState, (user: IUserState) => !user.tariff_ends_at);

export const selectNameOfTariff = createSelector(selectUserState, (user: IUserState) => user.tariff_name);

export const selectTariffMaxProject = createSelector(selectUserState, (user: IUserState) => user.max_projects);
